import { css } from '@emotion/react'
import styles, { typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const {
  colors: { gray },
} = styles

const S = css`
  display: flex;
  align-items: center;

  button.input:last-of-type {
    margin-left: 8px;
  }

  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  .problem-count {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 32px;
    background: white;
    border: 1px solid ${gray.$400};
    border-radius: var(--Radius-100);
    color: ${gray.$900};
    ${typo.body02};
    &.disabled {
      background-color: ${gray.$100};
      color: ${colors.gray.$500};
    }
  }

  .problem-count-input input {
    width: 48px;
    height: 32px;
  }

  .dec-button,
  .inc-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    width: 32px;
    border: 1px solid ${gray.$400};
    border-radius: var(--Radius-100);
    text-align: center;
    background: white;
    svg path {
      fill: ${gray.$600};
    }

    &:disabled {
      background-color: ${gray.$100};
      cursor: not-allowed;
      svg path {
        fill: ${gray.$400};
      }
    }
  }
  .dec-button {
    margin-right: 8px;
  }
  .inc-button {
    margin-left: 8px;
  }

  .input {
    position: absolute;
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
  }
`

export default S
